<template>
  <svg aria-hidden="true" class="svg-icon">
    <use :xlink:href="iconName"/>
  </svg>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  name: {
    type: String,
    required: true
  },
  color: {
    type: String,
    default: ''
  }
})

const iconName = computed(() => `#icon-${props.name}`)
</script>

<style lang="less" scoped>
</style>
